import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 288,
			height: 16,
			x: 112,
			y: 152,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 288,
			height: 16,
			x: 112,
			y: 240,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 152,
			height: 16,
			x: 112,
			y: 328,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 400,
			height: 400,
			x: 56,
			y: 56,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 16
		})
	]
});
export default SvgNotes;
